export type ManageSurveyTabKey =
  | 'TRAFFIC_CHANNELS'
  | 'EDIT_DETAILS'
  | 'EDIT_AUDIENCE'
  | 'SUPPLIERS'
  | 'MULTI_COUNTRY'
  | 'TRACKER'
  | 'GROUPED'
  | 'ACTIVITY_LOGS'
  | 'MARGIN_MAX'
  | 'RECONCILE'
  | 'HEALTH_CHECKS'
  | 'REPORTS'
  | 'AUDIENCE'
  | 'LINK_OTHER_DETAILS';

export interface ManageSurveyTab {
  readonly key: ManageSurveyTabKey;
  readonly label: string;
  readonly overflow: boolean;
}

export const MANAGE_SURVEY_TABS: readonly ManageSurveyTab[] = [
  { key: 'TRAFFIC_CHANNELS', label: 'Traffic Channels', overflow: false },
  { key: 'EDIT_DETAILS', label: 'Edit Details', overflow: false },
  { key: 'EDIT_AUDIENCE', label: 'Edit Audience', overflow: false },
  { key: 'SUPPLIERS', label: 'Supplier Mix', overflow: false },
  { key: 'MULTI_COUNTRY', label: 'Multi Country', overflow: false },
  { key: 'TRACKER', label: 'Tracker', overflow: false },
  { key: 'GROUPED', label: 'Grouped', overflow: false },
  { key: 'ACTIVITY_LOGS', label: 'Activity Logs', overflow: false },
  { key: 'MARGIN_MAX', label: 'Margin Max', overflow: false },
  { key: 'RECONCILE', label: 'Reconcile', overflow: false },
  { key: 'HEALTH_CHECKS', label: 'Health Checks', overflow: true },
  { key: 'REPORTS', label: 'Reports', overflow: true },
  { key: 'AUDIENCE', label: 'Audience', overflow: true },
  {
    key: 'LINK_OTHER_DETAILS',
    label: 'Links & Other Details',
    overflow: true,
  },
];
